import service from '@/utils/server';

const modName='/report/reportDistribute/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'distributeInfo',
    method: 'post',
    data
  });
};

//查询方法
export const pageInfoDetails = data => {
  return service({
    url: modName + 'distributeInfoDetails',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/report/distribute/api/index.js